import React from "react";
import UserFormScreen from "./UserFormScreen";
import { EmptyState, Link, ScreenContainer } from "../components/wombat-ui";
import useViewer from "../hooks/useViewer";
import useTranslations from "../hooks/useTranslations";

const DEFAULT_VALUES = {
  id: null,
  name: "",
  email: "",
  locale: "fr",
  role: "user",
  avatar: {
    filename: "",
    data: "",
  },
};

const NewUserScreen: React.FC = () => {
  const t = useTranslations();
  const { isCapableOfInsertingUsers } = useViewer();

  return (
    <ScreenContainer
      error={
        !isCapableOfInsertingUsers ? (
          <EmptyState
            title={t("network.unauthorized") as string}
            action={
              <Link variant="button" to="/">
                {t("network.backToHome")}
              </Link>
            }
          />
        ) : undefined
      }
    >
      <UserFormScreen defaultValues={DEFAULT_VALUES} />
    </ScreenContainer>
  );
};

export default NewUserScreen;
